import React from "react";
import CreditRing from "./CreditRing";

export default function CreditMeters({ credits, pools, plan }) {
  const allot = { enrichment: plan?.included_enrichment || 1500, scrape: plan?.included_scrape || 600 };
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-5" data-testid="credit-meters">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="text-base md:text-lg font-semibold text-slate-900">Your credits</h2>
        <p className="text-[11px] text-slate-500">
          Included credits reset every renewal · purchased credits never expire · included are used first
        </p>
      </div>
      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-6">
        {["enrichment", "scrape"].map((pool) => (
          <CreditRing
            key={pool}
            pool={pool}
            label={pools?.[pool]?.label || pool}
            backedBy={pools?.[pool]?.backed_by}
            unit={pools?.[pool]?.unit}
            included={credits?.[pool]?.included || 0}
            purchased={credits?.[pool]?.purchased || 0}
            allotment={allot[pool]}
          />
        ))}
      </div>
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4 border-t border-slate-100 pt-4">
        {["enrichment", "scrape"].map((pool) => (
          <div key={pool} data-testid={`credit-cheatsheet-${pool}`}>
            <div className="text-[11px] uppercase tracking-wider text-slate-500 font-medium">What {pools?.[pool]?.label?.toLowerCase() || pool} pay for</div>
            <ul className="mt-1.5 space-y-1 text-sm text-slate-700">
              {(pools?.[pool]?.pays_for || []).map((line) => (
                <li key={line} className="flex gap-2"><span className="text-slate-300">•</span><span>{line}</span></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
